import Vue from 'vue';
import feathersClient from '../../feathers-client';

const defaultSkillTreePagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultSkillTreeFilter = {
	$skip: defaultSkillTreePagination.$skip,
	$limit: defaultSkillTreePagination.$limit,
};

const defaultStaffSkillTreePagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultStaffSkillTreeFilter = {
	$skip: defaultStaffSkillTreePagination.$skip,
	$limit: defaultStaffSkillTreePagination.$limit,
};

export default {
	namespaced: true,
	state: {
		skillTree: [],
		skillTreeFilter: defaultSkillTreeFilter,
		skillTreePagination: defaultSkillTreePagination,
		networkPersona: [],
		staffSkillTree: [],
		staffSkillTreeFilter: defaultStaffSkillTreeFilter,
		staffSkillTreePagination: defaultStaffSkillTreePagination,
		exportTrustSkillFilter: {
			jobTitle: [],
			trust: [],
		},

	},
	getters: {
		skillTreePage: (state) => {
			const { $limit, $skip } = state.skillTreePagination;
			return $skip / $limit + 1;
		},
		staffSkillTreePage: (state) => {
			const { $limit, $skip } = state.staffSkillTreePagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_SKILL_TREE: (state, skillTree) => { state.skillTree = skillTree; },
		SET_SKILL_TREE_PAGINATION: (state, data) => { state.skillTreePagination = { ...state.skillTreePagination, ...data }; },
		SET_SKILL_TREE_FILTER: (state, filter) => { state.skillTreeFilter = { ...state.skillTreeFilter, ...filter }; },
		SET_DEFAULT_SKILL_TREE_FILTER: (state, filter) => { state.skillTreeFilter = { ...filter, ...defaultSkillTreeFilter }; },
		SET_NETWORK_PERSONA: (state, networkPersona) => {state.networkPersona = networkPersona},

		//staff
		SET_STAFF_SKILL_TREE: (state, staffSkillTree) => { state.staffSkillTree = staffSkillTree; },
		SET_STAFF_SKILL_TREE_PAGINATION: (state, data) => { state.staffSkillTreePagination = { ...state.staffSkillTreePagination, ...data }; },
		SET_STAFF_SKILL_TREE_FILTER: (state, filter) => { state.staffSkillTreeFilter = { ...state.staffSkillTreeFilter, ...filter }; },
		SET_DEFAULT_STAFF_SKILL_TREE_FILTER: (state, filter) => { state.staffSkillTreeFilter = { ...filter, ...defaultStaffSkillTreeFilter }; },
		SET_EXPORT_TRUST_SKILLS_FILTER: (state, filter) => { state.exportTrustSkillFilter = { ...state.exportTrustSkillFilter, ...filter }; },
	},
	actions: {
		setSkillTreeFilter: ({ commit }, filter) => {
			commit('SET_SKILL_TREE_FILTER', filter);
		},
		setExportTrustSkillsFilter: ({ commit }, filter) => {
			commit('SET_EXPORT_TRUST_SKILLS_FILTER', filter);
		},
		setDefaultSkillTreeFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_SKILL_TREE_FILTER', filter);
		},
		//staff
		setStaffSkillTreeFilter: ({ commit }, filter) => {
			commit('SET_STAFF_SKILL_TREE_FILTER', filter);
		},
		setDefaultStaffSkillTreeFilter: ({ commit }, filter) => {
			commit('SET_STAFF_DEFAULT_SKILL_TREE_FILTER', filter);
		},
		setSkillTreePage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.skillTreePagination.$limit;
			commit('SET_SKILL_TREE_PAGINATION', { $skip });
			commit('SET_SKILL_TREE_FILTER', { $skip });
		},
		//staff
		setStaffSkillTreePage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.staffSkillTreePagination.$limit;
			commit('SET_STAFF_SKILL_TREE_PAGINATION', { $skip });
			commit('SET_STAFF_SKILL_TREE_FILTER', { $skip });
		},
		getSkillTree: async({ commit, rootGetters }, filter) => {
			
			const results = await feathersClient.service('/api/v3/skill-network').find({
				query: {
					$role: rootGetters.currentUserRole,
					...filter,
				},

			});
			commit('SET_SKILL_TREE', results);
			const totalCount = results.length;
			commit('SET_SKILL_TREE_PAGINATION', { total: totalCount });
			return results;
		},

		getUserPermissionsOfTrust: async ({ rootGetters }, query) => {
			const url = '/api/v3/user-permissions-of-trust'; // trust-admin
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...query } });
			return results;
		},
		getStaffUserData({ commit }, userData) {
			commit('SET_STAFF_SKILL_TREE', userData);
		  },
		  searchNetworkPersonas: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/personas';
			const results = await feathersClient.service(url).find({ query: { ...filter, $role: rootGetters.currentUserRole, $paginate: false, category: 'SHIFT' } });
			commit('SET_NETWORK_PERSONA', results.data);
			return results.data;
		},
		addThreshold: async ({ rootGetters }, threshold) => {
			const url = '/api/v3/confidence-threshold';
			const results = await feathersClient.service(url).create(threshold, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		getThreshold: async ({ rootGetters }) => {
			const url = '/api/v3/confidence-threshold';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole } });
			return results.data;
		},
		updateThreshold: async ({ rootGetters }, threshold) => {
			const url = '/api/v3/confidence-threshold';
			const results = await feathersClient.service(url).patch(threshold.id, threshold, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		getExportSkills: async ({ rootGetters }, filter) => {
			const url = '/api/v3/export-trust-skills';
			const results = await feathersClient.service(url).find({ query: { ...filter, $role: rootGetters.currentUserRole } });
			return results;
		},
	},
};
